(function () {
  const initSliders = () => {
    $(".tabs-section").each(function () {
      if ($(this).hasClass("slider_started")) return;
      $(this).addClass("slider_started");

      const id = $(this).attr("id");
      const box = $(this).find(".tabs");
      const autoplay = box.data("autoplay");
      const delay = box.data("delay") * 1000;

      // ▼ 初期白画面防止＆フェードイン準備
      const section = $(this);
      section.css({
        opacity: 0,
        transition: "opacity 0.4s ease-in-out",
      });

      $(this)
        .find(".tabs_box, .tabs_box-content, .tabs-thumb_wrapper")
        .css({
          opacity: "1",
          visibility: "visible",
          transition: "none",
        });

      let swiperParms = {
        effect: box.data("effect"),
        speed: box.data("speed") * 1000,
        slidesPerView: 1,
        autoHeight: false,
        keyboard: true,
        loop: false,
        watchSlidesProgress: true,
        allowTouchMove: false,
      };

      if (autoplay) {
        swiperParms.autoplay = {
          delay: delay,
          disableOnInteraction: false,
        };
      }

      // ▼ Swiper初期化（即時実行）
      const initialize = () => {
        const mainSwiper = new Swiper(`#${id} .tabs_box`, swiperParms);
        const secondSwiperElement = $(this).find(".tabs_box-content");

        if (secondSwiperElement.length > 0) {
          const secondSwiper = new Swiper(
            `#${id} .tabs_box-content`,
            swiperParms
          );

          // ▼ fadeモードの軽量可視化制御
          const applyFadeFix = (swiper) => {
            const updateVisibility = () => {
              swiper.slides.forEach((slide, index) => {
                const active = index === swiper.activeIndex;
                slide.style.opacity = active ? "1" : "0";
                slide.style.visibility = active ? "visible" : "hidden";
                slide.style.pointerEvents = active ? "auto" : "none";
              });
            };
            swiper.on("init", updateVisibility);
            swiper.on("slideChangeTransitionStart", updateVisibility);
          };

          applyFadeFix(secondSwiper);
          secondSwiper.init();

          // ▼ 同期制御
          mainSwiper.on("slideChange", () => {
            secondSwiper.slideTo(mainSwiper.activeIndex);
          });
          secondSwiper.on("slideChange", () => {
            mainSwiper.slideTo(secondSwiper.activeIndex);
          });
        }

        // ▼ サムネイル制御
        const sliderThumbs = new Swiper(`#${id} .tabs-thumb_wrapper`, {
          spaceBetween: 16,
          slidesPerView:
            $(this).find(".tabs_wrapper-type3").length > 0
              ? box.data("per-row")
              : 1.4,
          speed: box.data("speed") * 1000,
          freeMode: false,
          allowTouchMove: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          loop: false,
          breakpoints: {
            576: {
              slidesPerView:
                $(this).find(".tabs_wrapper-type3").length > 0
                  ? box.data("per-row")
                  : 2.2,
            },
            990: {
              slidesPerView: box.data("per-row"),
              allowTouchMove: false,
            },
          },
        });

        const updateActiveSlide = () => {
          const activeIndex = mainSwiper.realIndex;
          sliderThumbs.slides.forEach((slide, i) => {
            slide.classList.toggle("active", i === activeIndex);
          });
          sliderThumbs.slideTo(activeIndex);
        };

        mainSwiper.on("slideChange", updateActiveSlide);

        sliderThumbs.on("click", () => {
          const clickedIndex = sliderThumbs.clickedIndex;
          if (clickedIndex != null) {
            mainSwiper.slideTo(clickedIndex);
            sliderThumbs.slideTo(clickedIndex);
          }
        });

        sliderThumbs.slides[0]?.classList.add("active");

        // ▼ 初期フェードイン（0.4秒）
        requestAnimationFrame(() => {
          section.css("opacity", "1");
        });
      };

      initialize();
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    initSliders();
    document.addEventListener("shopify:section:load", initSliders);
  });
})();
